import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PosPersonReferenceModalComponent } from 'src/app/shared/pos-person-reference-modal/pos-person-reference-modal.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosPersonReferenceModalService {

  private modalRef: BsModalRef = new BsModalRef();
  constructor(private modalService: BsModalService) {


  }

  show(form: FormGroup, confirmAction: (form: FormGroup) => any, isShortFormActiveForPlan?:boolean) {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(PosPersonReferenceModalComponent);
      this.modalRef.setClass(`modal-dialog modal-md ${ModalDialogType.PRIMARY}`);
      this.modalRef.content.form = form;
      this.modalRef.content.confirmAction = confirmAction;
      this.modalRef.content.isShortFormActiveForPlan = isShortFormActiveForPlan;
      resolve(true);
    });
  }
}
